import { Model } from 'pinia-orm';
import User from './User';
import Company from './Company';
import Job from "./Job";
import Application from "./Application";
import Interview from "./Interview";

export default class Subscription extends Model {
    static entity = 'subscriptions';

    static fields() {
        return {
            id: this.uid(),
            user_id: this.attr(null),
            company_id: this.attr(null),
            required: this.attr(false),
            subable_id: this.attr(null),
            subable_type: this.attr(null),
            user: this.belongsTo(User, 'user_id'),
            company: this.belongsTo(Company, 'company_id'),
            subable: this.morphTo(
                [Job, Application, Company, Interview],
                'subable_id',
                'subable_type'
            ),
        }
    }
}
